import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type ProfilEcriture from '../../../interfaces/pieces/mouvements/profilEcriture';

export const getProfilEcritures = (params: URLSearchParams) => {
	const url = '/api/finances/baseunique/profilsEcritures?';
	return request.get<unknown, TemplateRequestGet<ProfilEcriture>>(
		`${url}${params.toString()}`,
	);
};

export default getProfilEcritures;
